<script setup lang="ts">
import type {
  EventsOverviewProduct,
  Product,
  ProductPreference,
} from "mws-ts-v2-sdk";

import bidTitle from "~/utils/parseBidTitle";

type PropsProduct =
  | Product
  | EventsOverviewProduct
  | (ProductPreference & { isFollowedByUser?: boolean });

const { product, isFinished } = defineProps<{
  currentPrice: {
    value: number;
    currencyCode: string;
  };
  product: PropsProduct;
  isFinished: boolean;
}>();

const bidTitleTranslation = computed(() => {
  return bidTitle({
    hasBid: product.hasBid,
    isFinished,
  });
});
</script>

<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      class="uppercase text-sm text-platform-text-3"
      data-test="product-card-bid-title"
    >
      {{ $t(bidTitleTranslation) }}
    </div>
  </Transition>

  <span
    v-if="product.hasBid"
    class="font-semibold"
  >
    <Transition
      name="fade"
      mode="out-in"
    >
      <BaseCurrency
        :key="currentPrice.value"
        :iso="currentPrice.currencyCode"
        :value="currentPrice.value"
      />
    </Transition>
  </span>
</template>
